import React from 'react';
import { connect } from 'react-redux';
import ReclamationsRetourPlateformeTable from './ReclamationsRetourPlateformeTable';
import withLoader from 'components/Shared/withLoader';

import { fetchReclamationsMagasin, generatePackingList, toggleSurPaletteRetour } from 'store/reclamation/reclamationsActions';



const ReclamationsRetourPlateformeTableWithLoader = withLoader(ReclamationsRetourPlateformeTable);

class ReclamationsRetourPlateformeTableContainer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            plateformeCode: ''
        }
    }  


    async componentDidUpdate(prevProps) {
        // On refetche à la fin de la génération
        if (!this.props.isGeneratingPackingList && prevProps.isGeneratingPackingList) {
            await this.props.fetchReclamationsMagasin();
        }
    }

    toggleSurPaletteRetour = async (reclamationId) => {
        await this.props.toggleSurPaletteRetour(reclamationId);
    }

    handleChangePlateformeCode = (e) => {

        this.setState({ plateformeCode: e.target.value});
    }

    render() {

        const { reclamations, isLoading, isGeneratingPackingList, generatePackingList, codeDepot } = this.props;
        const { plateformeCode } = this.state;


        return <ReclamationsRetourPlateformeTableWithLoader
            onChangePlateformeCode={this.handleChangePlateformeCode}
            reclamations={reclamations}
            isLoading={isLoading}
            isGeneratingPackingList={isGeneratingPackingList}
            generatePackingList={generatePackingList}
            codeDepot={codeDepot}
            toggleSurPaletteRetour={this.toggleSurPaletteRetour}
            plateformeCode={plateformeCode}
        />;
    }
}


const mapStateToProps = (state, props) => {
    let reclamations = state.reclamation.reclamations.reclamationsMagasin.items;

    return {
        reclamations: reclamations,
        isLoading: state.reclamation.reclamations.reclamationsMagasin.isLoading,
        isGeneratingPackingList: state.reclamation.reclamations.reclamationsMagasin.isGeneratingPackingList,
        codeDepot: state.reclamation.reclamations.recherche.criteres.codeDepot
    };
};

const mapDispatchToProps = (dispatch)  => ({
    fetchReclamationsMagasin: () => dispatch(fetchReclamationsMagasin()),
    generatePackingList: (param) => dispatch(generatePackingList(param)),
    toggleSurPaletteRetour: (reclamationId) => dispatch(toggleSurPaletteRetour(reclamationId))
});

export default connect(mapStateToProps, mapDispatchToProps)(ReclamationsRetourPlateformeTableContainer);
